<template>
  <div class="ebc-main">
    <vxe-grid
      v-if="data.length"
      size="small"
      border
      resizable
      auto-resize
      show-overflow
      highlight-hover-row
      :height="635"
      :data="data"
      :columns="tableColumns"
    >
      <template #bookingNo="{ row }">
        <el-input
          :value="row.bookingNo"
          size="mini"
          :placeholder="$l('form_placeholder_billNo') || '输入提单号'"
          clearable
          @input="(val) => $emit('update-row', row, 'bookingNo', val)"
        />
      </template>

      <template #customsNo="{ row }">
        <el-input
          :value="row.customsNo"
          size="mini"
          :placeholder="$l('form_placeholder_customsNo') || '输入关单号'"
          clearable
          @input="(val) => $emit('update-row', row, 'customsNo', val)"
        />
      </template>

      <template #remove="{ row }">
        <el-button
          type="text"
          size="mini"
          style="color:#f56c6c"
          @click="$emit('remove', row)"
        >
          {{ $l('btn_remove') || '移除' }}
        </el-button>
      </template>
    </vxe-grid>

    <div v-else class="ebc-empty">
      <slot name="header" />
      <div class="ebc-empty__body">
        <i class="el-icon-box" style="font-size:28px;color:#cbd5e1;" />
        <span>{{ $l('tips_no_related_container') || '暂未选择关联分柜' }}</span>
      </div>
    </div>

    <div v-if="data.length" class="ebc-summary">
      <span class="ebc-summary__item">
        <span class="ebc-summary__lbl">
          {{ $l('label_total_goods_piece_qty') || '总件数' }}
        </span>
        <span class="ebc-summary__val">{{ summary.totalGoodsQty }}</span>
      </span>
      <span class="ebc-summary__div" />
      <span class="ebc-summary__item">
        <span class="ebc-summary__lbl">
          {{ $l('form_label_totalCtnQty') || '总箱数' }}
        </span>
        <span class="ebc-summary__val">{{ summary.totalCtnQty }}</span>
      </span>
      <span class="ebc-summary__div" />
      <span class="ebc-summary__item">
        <span class="ebc-summary__lbl">
          {{ $l('label_total_weight') || '总重' }}
        </span>
        <span class="ebc-summary__val">{{ summary.totalWeight }} kg</span>
      </span>
      <span class="ebc-summary__div" />
      <span class="ebc-summary__item">
        <span class="ebc-summary__lbl">
          {{ $l('label_total_volume') || '总体积' }}
        </span>
        <span class="ebc-summary__val">{{ summary.totalVolume }} m³</span>
      </span>
      <span class="ebc-summary__div" />
      <span class="ebc-summary__item">
        <span class="ebc-summary__lbl">
          {{ $l('label_total_booking_volume') || '总订舱体积' }}
        </span>
        <span class="ebc-summary__val">{{ summary.totalBookingVolume }} m³</span>
      </span>
      <span class="ebc-summary__div" />
      <span class="ebc-summary__item money">
        <span class="ebc-summary__lbl">{{ $l('label_cost') || '成本' }}</span>
        <span class="ebc-summary__val">{{ summary.costLabel }}</span>
      </span>
      <span class="ebc-summary__div" />
      <span class="ebc-summary__item money">
        <span class="ebc-summary__lbl">{{ $l('label_sales') || '销售' }}</span>
        <span class="ebc-summary__val">{{ summary.salesLabel }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import tableColumns from './table-columns'

import { add, round } from '@/libs/util.number'

export default {
  props: {
    data: { type: Array, default: () => [] },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
  computed: {
    summary() {
      const d = this.data
      const totalGoodsQty = d.reduce(
        (s, r) => add(s, r.containerGoodsQty || 0),
        0
      )
      const totalCtnQty = d.reduce((s, r) => add(s, r.containerBoxQty || 0), 0)
      const totalWeight = round(
        d.reduce(
          (s, r) =>
            add(
              s,
              r.totalWeight ||
                add(r.containerWeight || 0, r.containerGrossWeight || 0)
            ),
          0
        ),
        2
      )
      const totalVolume = round(
        d.reduce((s, r) => add(s, r.containerVolume || 0), 0),
        2
      )
      const totalBookingVolume = round(
        d.reduce((s, r) => add(s, r.containerBookingVolume || 0), 0),
        2
      )
      const totalCost = round(
        d.reduce((s, r) => add(s, r.containerCostAmount || 0), 0),
        2
      )
      const totalSales = round(
        d.reduce((s, r) => add(s, r.containerSalePriceAmount || 0), 0),
        2
      )
      const costCurrencyUnit =
        d[0]?.costCurrencyUnitName || d[0]?.costCurrencyUnit || ''
      const salesCurrencyUnit =
        d[0]?.salesCurrencyUnitName || d[0]?.salesCurrencyUnit || ''
      return {
        totalGoodsQty,
        totalCtnQty,
        totalWeight,
        totalVolume,
        totalBookingVolume,
        costLabel: [costCurrencyUnit, totalCost].filter(Boolean).join(' '),
        salesLabel: [salesCurrencyUnit, totalSales].filter(Boolean).join(' '),
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ebc-main {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ebc-empty {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px 12px;
}

.ebc-empty__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #94a3b8;
  font-size: 12px;
  border: 1px dashed #cbd5e1;
  border-radius: 4px;
  min-height: 120px;
}

.ebc-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 6px 12px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
  flex-shrink: 0;
}

.ebc-summary__item {
  display: inline-flex;
  align-items: baseline;
  gap: 3px;
  white-space: nowrap;
  font-size: 10px;

  &.money .ebc-summary__val {
    color: #059669;
  }
}

.ebc-summary__lbl {
  color: #64748b;
  font-weight: 500;
}

.ebc-summary__val {
  color: #0f172a;
  font-weight: 700;
  font-size: 11px;
  font-family: 'SF Mono', 'Menlo', 'Consolas', monospace;
}

.ebc-summary__div {
  width: 1px;
  height: 14px;
  background: #e2e8f0;
  margin: 0 6px;
  flex-shrink: 0;
}
</style>
